import Map from './components/Map/Map';
import Table from './components/Table/Table';
import { useCallback, useState, useEffect, useRef } from 'react';
import { Dropdown } from 'semantic-ui-react'

import Constants from './constants/constants';
import dataHelper from './helpers/dataHelper';

import './App.css';
import 'semantic-ui-css/semantic.min.css';

function getCityFromSearchProps() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.has("grad") ? urlSearchParams.get("grad") : "";
}

function App() {
    const [city, setCity] = useState(getCityFromSearchProps());
    const [sector, setSector] = useState("ukupno");
    const [pollutant, setPollutant] = useState("");
    const [pollutantOptions, setPollutantOptions] = useState([]);
    const [tableData, setTableData] = useState({});
    const [geoJSONData, setGeoJSONData] = useState(null);
    const [selectedGridId, setSelectedGridId] = useState();
    const [maxPollutant, setMaxPollutant] = useState(0);
    const [breaks, setBreaks] = useState([]);

    const sectorsDropdownRef = useRef();
    const pollutantsDropdownRef = useRef();

    const fetchGeoJson = useCallback(async () => {
        const url = dataHelper.getGeojsonUrl(city, sector);

        const data = await dataHelper.getGeojsonData(url);
        setGeoJSONData(data);
    }, [city, sector]);


    useEffect(() => {
        fetchGeoJson();
    }, [city, fetchGeoJson, sector]);

    useEffect(() => {
        if (!geoJSONData) {
            setTableData({});
            return;
        }

        if (!selectedGridId) {
            setTableData(dataHelper.getPollutantsSum(geoJSONData));
        } else {
            setTableData(dataHelper.getGridPollutants(selectedGridId, geoJSONData));
        }

        setPollutantOptions(dataHelper.getPollutantOptionsForDropdown(geoJSONData));
    }, [selectedGridId, geoJSONData]);

    useEffect(() => {
        if (!geoJSONData || !pollutant) {
            return;
        }

        const _breaks = dataHelper.getNaturalBreaks(geoJSONData, pollutant);
        if (_breaks && _breaks.length) {
            setBreaks(_breaks);
            const _maxPollutant = _breaks.pop();
            setMaxPollutant(_maxPollutant);
        }
    }, [geoJSONData, pollutant]);

    const onCitySelect = (_event, data) => {
        setCity(data.value);
        onSectorSelect(null, Constants.ALL_SECTORS_FOR_DROPDOWN[0]);
    };

    const onSectorSelect = (_event, data) => {
        setSector(data.value);
        pollutantsDropdownRef.current.clearValue();
        setSelectedGridId(undefined);

    };

    return (
        <div className="App">
            <div className="App-map">
                <Map
                    city={city}
                    pollutant={pollutant}
                    geoJSONData={geoJSONData}
                    maxPollutant={maxPollutant}
                    breaks={breaks}
                    selectedGridId={selectedGridId}
                    setSelectedGridId={setSelectedGridId}
                    sector={sector}
                />
            </div>
            <div className='App-content'>
                <div className="dropdown-wrapper">
                    <Dropdown
                        className="App-dropdown"
                        placeholder='Odaberi grad'
                        selection
                        defaultValue={city}
                        options={Constants.ALL_CITIES_FOR_DROPDOWN}
                        disabled={new URLSearchParams(window.location.search).has("grad")}
                        onChange={onCitySelect}
                        item
                    />
                    <Dropdown
                        className="App-dropdown"
                        placeholder='Odaberi sektor'
                        selection
                        options={Constants.ALL_SECTORS_FOR_DROPDOWN}
                        disabled={!city}
                        defaultValue={sector}
                        value={sector}
                        onChange={onSectorSelect}
                        item
                        ref={sectorsDropdownRef}
                    />
                    <Dropdown
                        className="App-dropdown"
                        placeholder='Odaberi polutant'
                        selection
                        clearable
                        options={pollutantOptions}
                        disabled={!sector}
                        onChange={(_event, data) => setPollutant(data.value)}
                        item
                        ref={pollutantsDropdownRef}
                    />
                </div>
                <div className="table-wrapper">
                    <Table
                        data={tableData}
                        activePollutant={pollutant}
                        breaks={breaks}
                        selectedGridId={selectedGridId}
                        sector={sector}
                    />
                </div>
            </div>
        </div>
    );
}

export default App;
